/**
 * Tool used on the canvas
 */
export enum DrawingTool {
  Brush = 'brush',
  Eraser = 'eraser',
}
